import { getLocale } from './localization';

export const normalizeCurrency = (value: unknown, fallback = 'USD'): string => {
  const currency = typeof value === 'string' ? value.trim().toUpperCase() : '';
  return /^[A-Z]{3}$/.test(currency) ? currency : fallback;
};

export const getDefaultCurrency = (settings: any, fallback = 'USD'): string =>
  normalizeCurrency(
    settings?.defaultCurrency ?? settings?.default_currency ?? settings?.currency,
    fallback,
  );

export const formatCurrency = (
  amount: number,
  currency: unknown,
  options: Intl.NumberFormatOptions = {},
  locale = getLocale(),
): string => {
  const normalizedCurrency = normalizeCurrency(currency);
  const value = Number(amount) || 0;

  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: normalizedCurrency,
      ...options,
    }).format(value);
  } catch {
    return `${normalizedCurrency} ${value.toLocaleString(locale, {
      minimumFractionDigits: 2,
      ...options,
    })}`;
  }
};
